import { render, staticRenderFns } from "./MiniAppList.vue?vue&type=template&id=64303a99&scoped=true"
import script from "./MiniAppList.vue?vue&type=script&lang=js"
export * from "./MiniAppList.vue?vue&type=script&lang=js"
import style0 from "./MiniAppList.vue?vue&type=style&index=0&id=64303a99&prod&scoped=true&lang=css"
import style1 from "./MiniAppList.vue?vue&type=style&index=1&id=64303a99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64303a99",
  null
  
)

export default component.exports